// ABOUTME: SPEC-82 §4.10 — the Enter-screen voice hint and the "How it works" line in one place: type, glyph, spacing, and the
// ABOUTME: authored height reserved for them so the read-first card (SPEC-76) shrinks by exactly what the panel grew by.

// Authored units in the gate panel's own unit (RAIL_UNIT desktop / MOBILE_UNIT on a phone), like every other gate size.
export const HINT = {
  font: 34,          // the read-first card's own type size (TutorialPrimer TEXT_AUTHORED)
  minPx: 13,         // legibility floor for a handset; the card's own floor is 12
  leading: 1.2,
  iconH: 48,         // the mic glyph, a non-interactive pictogram
  iconGap: 16,
  glyphAspect: 46 / 73.459, // /reel-chrome/icon-mic.svg
};

export const COLLAPSE = {
  font: 34,
  minPx: 13,
  leading: 1.2,
  padX: 24,
  chevron: 12,
};

// Space between the hint row and the "How it works" line inside the one block the panel gains.
export const BLOCK_GAP = 16;

// The panel's own flex gap (EnterBoutiqueGate PANEL_GAP) separates the new block from the button.
export const PANEL_GAP_AUTHORED = 45.333;

/** Authored height of one text line at `font` and `leading`. */
const lineH = (font, leading) => font * leading;

/**
 * How much taller the Enter panel gets with these toggles on, in authored units — what the card under it must give up.
 * 0 with neither toggle (flag-off tenants reserve exactly what they always did).
 */
export function hintReserve({ voiceHint, collapsible }) {
  if (!voiceHint && !collapsible) return 0;
  const rows = [];
  if (voiceHint) rows.push(Math.max(HINT.iconH, lineH(HINT.font, HINT.leading)));
  if (collapsible) rows.push(lineH(COLLAPSE.font, COLLAPSE.leading));
  const block = rows.reduce((a, b) => a + b, 0) + BLOCK_GAP * (rows.length - 1);
  return PANEL_GAP_AUTHORED + block;
}
